import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';

import { PartnersMainTable } from './index';
import { AddPartner } from './../../_common/AddPartner';

export const PartnersFilters = ({ filters, setFilters, pageSearch, setPageSearch, routerQuery }) => {


	const inputRef = useRef();
	useEffect(() => {
		if (routerQuery.search) {
			inputRef.current.focus();
		}

	}, []);

	return (
		<nav className="navbar navbar-expand-sm navbar-light px-0 mb-xl-2 mt-sm mt-xl-0">
			<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
				<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
				<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
			</button>
			<div className="collapse navbar-collapse flex-column" id="navbarNav">
				<form className="form-inline container-default mx-auto justify-content-center w-lg-75 w-xl-50" onSubmit={(e) => e.preventDefault()}>
					<div className={"my-1 input-group btn-dim rounded-max mr-2 ml-xl-auto w-100" + (pageSearch !== "" ? " active" : "")}>
						<input type="text" className="form-control bg-none rounded-inherit border-none no-focus shadow-none" placeholder="Recherche" aria-label="Recherche" ref={inputRef} value={pageSearch} onChange={(e) => setPageSearch(e.target.value)} />
						<div className="input-group-prepend rounded-inherit">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4"><i className="eva eva-search-outline align-middle fs-root lh-0 o-70 o-100--hover"></i></button>
						</div>
					</div>
					{/* <div className="my-1 input-group btn-dim rounded-max mr-2 btn-alert active" role="button">
							<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Les plus récents</p>
							<div className="input-group-prepend rounded-inherit dropdown">
								<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<i className="eva eva-funnel-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
								</button>
								<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButton">
									<button className="dropdown-item py-2 h6 mb-0 active" type="button">Les plus récents</button>
									<button className="dropdown-item py-2 h6 mb-0" type="button">Ordre alphabétique</button>
								</div>
							</div>
						</div> */}
					{/* <div className="my-1 input-group btn-dim rounded-max mr-2 btn-alert" role="button">
							<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonUsers" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Toutes les catégories</p>
							<div className="input-group-prepend rounded-inherit dropdown">
								<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonUsers" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<i className="eva eva-people-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
								</button>
								<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButtonUsers">
									<button className="dropdown-item py-2 h6 mb-0 active" type="button">Toutes les catégories</button>
									<button className="dropdown-item py-2 h6 mb-0" type="button">Notaire</button>
									<button className="dropdown-item py-2 h6 mb-0" type="button">Agences Funéraires</button>
								</div>
							</div>
						</div> */}
				</form>
			</div>
		</nav>
	);
};